import { render, staticRenderFns } from "./StandortForm.vue?vue&type=template&id=4283cfba&"
import script from "./StandortForm.vue?vue&type=script&lang=js&"
export * from "./StandortForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports